import React from 'react';
import { ArrowRight, ChevronRight, Fingerprint, Globe, Shield, Sparkles } from 'lucide-react';

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-[95vh] flex flex-col items-center justify-center pt-32 px-6 overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute top-1/3 left-1/4 w-[500px] h-[500px] bg-brand-blue/5 blur-[120px] rounded-full"></div>
        <div className="absolute bottom-1/3 right-1/4 w-[400px] h-[400px] bg-brand-blue/5 blur-[100px] rounded-full"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl w-full text-center">
        <div className="inline-flex items-center gap-4 px-6 py-3 bg-white/[0.03] border border-white/10 rounded-full mb-12 animate-in fade-in slide-in-from-bottom-4 duration-1000">
          <Sparkles size={16} className="text-brand-blue animate-pulse" />
          <span className="text-[10px] uppercase tracking-[0.4em] font-black text-white/70">A better way to engage with your people</span>
        </div>
        
        <div className="parallax-layer" data-speed="0.2">
          <h1 className="text-[10vw] md:text-[6.5rem] font-bold tracking-tighter leading-[0.8] mb-12 text-white title-glow">
            Boulai<span className="text-brand-blue animate-pulse">.</span>
          </h1>
        </div>
        
        <div className="max-w-4xl mx-auto mb-16 space-y-6 parallax-layer" data-speed="0.1">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-medium tracking-tight text-white/90 leading-tight">
            Infrastructure designed for leaders to <br/><span className="text-brand-blue italic hover:tracking-widest transition-all duration-700 cursor-default">engage directly.</span>
          </h2>
          <p className="text-xs md:text-sm text-white/40 max-w-lg mx-auto leading-relaxed font-black uppercase tracking-[0.5em]">
            Analyze immediately at scale, and decide with sovereignty-first confidence.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 mb-32">
          <a 
            href="mailto:mdahhan@boulai.net" 
            className="group px-14 py-6 bg-brand-blue text-white rounded-xl transition-all duration-500 flex items-center gap-4 active:scale-95 hover:bg-white hover:text-black shadow-2xl shadow-brand-blue/20 hover:shadow-white/20"
          >
            <span className="text-[11px] font-black uppercase tracking-[0.3em]">Request a Demo</span>
            <ArrowRight size={18} className="group-hover:translate-x-2 transition-transform" />
          </a>
          <a 
            href="#platform" 
            className="group flex items-center gap-3 text-white transition-all py-5 px-10 font-black uppercase text-[10px] tracking-[0.4em] hover:text-brand-blue"
          >
            <span className="group-hover:underline underline-offset-8">Platform Overview</span>
            <ChevronRight size={18} className="group-hover:translate-x-2 transition-transform" />
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-12 max-w-5xl mx-auto border-t border-white/5 pt-20">
          {[
            { icon: <Globe size={32} />, label: "Localized Infrastructure" },
            { icon: <Shield size={32} />, label: "Data Sovereignty" },
            { icon: <Fingerprint size={32} />, label: "Verified Input" }
          ].map((item, i) => (
            <div key={i} className={`flex flex-col items-center gap-6 group transition-all duration-500 hover:-translate-y-2 ${i === 2 ? 'hidden md:flex' : ''}`}>
              <div className="w-16 h-16 rounded-2xl border border-white/10 flex items-center justify-center bg-brand-blue/10 text-brand-blue group-hover:bg-brand-blue group-hover:text-white transition-all duration-500 group-hover:shadow-[0_0_30px_rgba(86,190,249,0.3)]">
                {item.icon}
              </div>
              <span className="text-[10px] uppercase tracking-[0.5em] font-black text-white/40 group-hover:text-white transition-colors text-center">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;